<template>
  <div>
    <Reverse-Map />
    <br>
    <Reverse-Table />
  </div>
</template>

<script>
import ReverseMap from '@/views/reverse/sub/ReverseMap.vue'
import ReverseTable from '@/views/reverse/sub/ReverseTable.vue'

export default {
  components: {
    ReverseMap,
    ReverseTable,
  },
}
</script>

<style>

</style>
